import { useEffect, useState } from 'react';
import { obtenerUsuariosConsultantesHistoricoPorFiltro,habilitarFichaConsultante} from '../data/FichaConsultante';
import { useContext } from "react";
import { AuthContext } from "auth";



export const useListarUsuariosConsultantesHistorico = () => {
    var {user,logout}= useContext(AuthContext);
    
    const [usuariosConsultantesHistorico, setUsuariosConsultantesHistorico] = useState([]);
    const [enabled, setEnabled] = useState(false);
    
    const getUsuariosConsultantesHistorico = async(filtro) => {
        
        const usuarios = await obtenerUsuariosConsultantesHistoricoPorFiltro(filtro,user.Token);
        setUsuariosConsultantesHistorico(usuarios);
    }

    const enabledFichaConsultante=async(Id) =>{
        if(Id!=undefined && Id!=''){
            const respuesta=await habilitarFichaConsultante(Id,user.Token);
            setEnabled(true)
            return respuesta;
        }
    }
    
    useEffect( () => {
        async function setListarUsuarios(){
            getUsuariosConsultantesHistorico();
        }
        setListarUsuarios();
        
    }, []);
    useEffect( () => {
        if(enabled){
            
            async function setListarUsuarios(){
                getUsuariosConsultantesHistorico();
            }
            setListarUsuarios();
            setEnabled(false)

        }
        

        
    }, [enabled]);
    
    return {
        usuariosConsultantesHistorico,
        getUsuariosConsultantesHistorico,
        enabledFichaConsultante
        
    }

}
